export default __webpack_public_path__ + "static/media/video-bg.a05f0f18.jpg";